module.exports = __webpack_public_path__ + "img/catita.260f445b.jpg";